import React, { ChangeEvent, useCallback } from 'react'
import { l } from '@manychat/manyui'

import FlowTextEditor from 'common/builder/components/misc/FlowTextEditor'
import { Field } from 'common/fields/entities/field'

import { TextAutocomplete } from './components/TextAutocomplete'

import cm from './TextInput.module.css'

type Value = string

type ChangeValueEvent = ChangeEvent<{ value: Value }>

interface TextInputProps {
  value: Value
  fieldId: Field['id']
  isBuilder: boolean
  onChange: (event: ChangeValueEvent, closePopover?: boolean) => void
}

const MIN_ROWS = 1
const MAX_ROWS = 6

export const TextInput: React.FC<TextInputProps> = ({ value, onChange, isBuilder, fieldId }) => {
  const placeholder = l.translate('Enter text')

  const handleChange = useCallback(
    (event: { target: { value: string | number } }) => {
      onChange(event as ChangeValueEvent)
    },
    [onChange],
  )

  return (
    <>
      {isBuilder ? (
        <div className={cm.textEditor}>
          <FlowTextEditor
            onChange={handleChange}
            value={value ?? ''}
            minRows={MIN_ROWS}
            maxRows={MAX_ROWS}
            placeholder={placeholder}
            isValid
            withDefaultStyles
          />
        </div>
      ) : (
        <TextAutocomplete
          fieldId={fieldId}
          value={value || ''}
          onChange={(event, closePopover) => onChange(event as ChangeValueEvent, closePopover)}
          placeholder={placeholder}
        />
      )}
    </>
  )
}
